import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, toRef } from "vue";
import QExpandableDataTable from "../../../components/datatables/QExpandableDataTable.vue";
import { AgencyMetricValues, MetricValues } from "../api";
import BlueBox from "./BlueBox.vue";
import { useColumnAverage } from "../composables/useColumnAverage";
import AgentNameCol from "./AgentNameCol.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AoAgencyDataTable',
  props: {
  items: { type: Array as PropType<(AgencyMetricValues)[]>, default: () => [] },
},
  setup(__props) {

const props = __props



const headers = [
	{
		text: "Agent Name",
		value: "AgentName",
	},
	{
		text: "APV per Agent",
		value: "APV_PerAgent",
	},
	{
		text: "Apps per Agent",
		value: "AppsPerAgent",
	},
	{
		text: "Writer",
		value: "Writer",
	},
	{
		text: "Average",
		value: "Average",
	},
];

// const top10Apv = useColumnAverage(toRef(props, 'items'), 'APV_PerAgent', 'MonthlyAPVPerAgent')
// const top10Apps = useColumnAverage(toRef(props, 'items'), 'AppsPerAgent', 'MonthlyAppsPerAgent')
// const top10Writer = useColumnAverage(toRef(props, 'items'), 'Writer', 'WritersPerAgent')

return { __sfc: true,props, headers, QExpandableDataTable, AgentNameCol }
}

})